import '../Common/Elements/Common.css'
import React, {useContext, useEffect, useState} from "react";

import './WalletView.css'
import {Button} from "../Common/Elements/Button";
import {useTranslation} from "react-i18next";
import {lytSmall} from "../Common/Icons/Icons";
import {List} from "../Common/Elements/List";
import {ExplytStoreItemEntry} from "../ExplytStore/ExplytStoreItem";
import {formatBalanceNumber} from "../../communication/format";
import {getTransactions, getUser, getWallets} from "../../communication/communication";
import {loading} from "../../communication/wrapped";
import {Loading, LoadingCircle} from "../Common/Loading/LoadingPlaceholder";
import {ShareLytAdminPopup} from "./ShareLytAdminPopup";
import {Popup} from "../Common/Elements/Popup";
import {itemOfType} from "../ExplytStore/ExplytStoreItems";
import {Claim, WaUser} from "../../types/farming";
import {SubscribeToSelection} from "../Common/Navigation/NavigationFooter";
import {Wallet} from "../../types/explyt";

function TestCreditBalance({balance} : {balance: number | undefined}) {
    const {t} = useTranslation();

    const color = !balance || balance > 50
        ? "var(--color-main)"
        : balance > 10
            ? "var(--color-yellow)"
            : "var(--color-red)"

    const displayBalance = balance !== undefined
        ? formatBalanceNumber(balance)
        : <Loading className="loading-balance"/>

    return <div className="entry-light-bg flex-y-center full-wide" style={{height: "4.5rem"}}>
        <div className="flex-row small-margin-left full-wide">
            <div className="flex-center">
                {lytSmall(color)}
            </div>
            <div className="flex-y-center">
                <span className="big-font font-white small-margin-left no-break"> {t("testCredits")}</span>
            </div>
            <div className="flex-y-center flex-right small-margin-right" style={{marginLeft: "auto"}}>
                <span className="big-font small-margin-left" style={{color: color}}> {displayBalance} </span>
            </div>
        </div>
    </div>
}

function PurchasedList() {
    const {t} = useTranslation();
    const [transactions, setTransactions] = useState(loading<Claim[]>(null!))

    useEffect(() => {
        getTransactions().then(setTransactions)
    }, []);

    const subscribeToNavigation = useContext(SubscribeToSelection)

    useEffect(() => {
        subscribeToNavigation((n) => {
            if (n !== 2) return;
            getTransactions().then(setTransactions)
        })
    }, []); // eslint-disable-line

    if (transactions.statusCode !== 200){
        return <div className="flex-center"> <LoadingCircle className="loading-circle-big"/> </div>
    }

    const explytItems = transactions.data
        ?.filter(e => e.subscription !== undefined)
        .map(e => itemOfType(t, e.subscription!.channel_id))
        .reverse()

    return <List
        collection={explytItems ?? []}
        createElement={e => <ExplytStoreItemEntry item={e}/>}
        elementHeight={60}
        id={"purchased-items"}
    />
}

function WalletView() {
    const {t} = useTranslation();
    const [showSendLyt, setShowSendLyt] = useState(false);

    const [wallets, setWallets] = useState(loading<Wallet[]>(null!));
    const [user, setUser] = useState(loading<WaUser>(null!))
    const subscribeToNavigation = useContext(SubscribeToSelection)

    const refreshWallets = () => {
        getWallets().then(setWallets);
    }

    useEffect(() => {
        subscribeToNavigation((n) => {
            if (n !== 2) return;
            refreshWallets()
        })
        refreshWallets();
        getUser().then(setUser)
    }, []); // eslint-disable-line


    // TODO: implement onClick logic here after buyLyt enabling
    const buyLytButton = <Button
        onClick={() => {}}
        text={t("buyLyt")}
        textColor={"var(--font-dim)"}
        backgroundColor="var(--progress-bar-button-bg)"
    />

    const shareLytButton = <Button
        onClick={() => setShowSendLyt(true)}
        text={t("sendLyt")}
        textColor={"black"}
        backgroundColor="white"
    />

    const testCreditBalance = wallets.data?.find(w => w.currency === "Credits")?.balance;

    const shareLytPopup = <Popup
        data={{}}
        contentFactory={d => <ShareLytAdminPopup {...d}/>}
        isOpen={showSendLyt}
        setIsOpen={setShowSendLyt}
        zIndex={10}
    />

    const buttons = user.data?.authorities?.includes("ROLE_ADMIN")
        ? <div className="small-margin" style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem"}}>
            {shareLytButton}
            {buyLytButton}
        </div>
        : <div className="small-margin">
            {buyLytButton}
        </div>

    return <div style={{display: "grid", gridTemplateRows: "1fr 8rem", height:"100%"}}>
        <div className="flex-column small-padding-top">
            <span className="small-margin big-font font-white"> {t("balance")} </span>
            <div className="small-margin flex-column small-margin-top" style={{gap: "0.5rem"}}>
                <TestCreditBalance balance={testCreditBalance}/>
            </div>
            <div className="small-margin" style={{paddingTop: "2rem"}}>
                <span className="big-font font-white"> {t("purchased")} </span>
            </div>
            <div style={{height: "calc(var(--app-height) - 27rem)"}} className="small-margin-top">
                <PurchasedList/>
            </div>
        </div>
        {buttons}
        {shareLytPopup}
    </div>
}

export function WalletViewDelayed() {
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        setLoaded(true);
    }, []);

    if (loaded) return <WalletView/>

    return <></>
}